type GovUserIdentity = {
    id?: unknown;
    role?: unknown;
};

const normalizedRole = (value: unknown): string => String(value || '').trim().toUpperCase();

export const canDeleteGovUser = (
    actor: GovUserIdentity | null | undefined,
    target: GovUserIdentity | null | undefined,
    visibleUsers: GovUserIdentity[],
): boolean => {
    const actorRole = normalizedRole(actor?.role);
    const targetRole = normalizedRole(target?.role);
    const actorId = String(actor?.id || '');
    const targetId = String(target?.id || '');

    if (!['SUPER_ADMIN', 'ADMINISTRADOR'].includes(actorRole)) return false;
    if (!actorId || !targetId || actorId === targetId) return false;
    if (actorRole === 'ADMINISTRADOR' && targetRole === 'SUPER_ADMIN') return false;
    if (
        targetRole === 'SUPER_ADMIN'
        && visibleUsers.filter((entry) => normalizedRole(entry.role) === 'SUPER_ADMIN').length <= 1
    ) return false;
    return true;
};

export const isConfirmedGovUserDeletion = (value: unknown, expectedId: string): boolean => {
    if (!value || typeof value !== 'object') return false;
    return (value as { deleted_id?: unknown }).deleted_id === expectedId;
};
